<!--
 * @Author: tong.lin
 * @Date: 2025-01-10 14:49:57
 * @LastEditors: tong.lin
 * @LastEditTime: 2025-01-14 15:54:33
 * @FilePath: /trunk/src/components/onLineUserList/volumeList.vue
 * @Description:
 * 码上发财
 * Copyright (c) 2025 by 263企业通信, All Rights Reserved.
-->
<template>
  <img :src="require(`@/svg/mic-sprite${positionX}.png`)" width="13px" />
</template>

<script>
export default {
  data() {
    return {
      positionX: 0,
    };
  },
  props: {
    volume: {
      type: Number,
      required: false
    }
  },
  created() {
    this.init(this.volume);
  },
  watch: {
    volume: {
      immediate: true,
      handler(val) {
        this.init(val)
      }
    }
  },
  methods: {
    init(volume) {
      this.positionX = this.volumeShow(Number(volume));

    },
    volumeShow(volume) {
      if (volume == 0 || isNaN(volume)) {
        volume = 1
      }
      const level = Math.ceil(volume / 20);
      return level - 1
    }
  },
};
</script>

<style scoped>
.volume-bar {
  height: 1.25rem;
  width: 1.25rem;
  background-repeat: no-repeat;
  background-size: 6.25rem auto;
  background-position: -0px -0px;
}

.big-volume-bar {
  height: 1.25rem;
  width: 0.9rem;
  background-size: 4.3rem auto;
  position: absolute;
  left: 1px;
  bottom: 1px;
}
.volume-abs {
  /* position: absolute;
  left: -3px;
  bottom: 0; */
}
</style>
